import Frame from "./../Frame";
import applyStyles from "../dom/applyStyles";
import {strings} from "@securionpay-internal/commons-js";
import {COMPANY_NAME} from "../../env";

export default class ThreeDSecureFrame extends Frame {

    overlay: HTMLDivElement;

    constructor(src, controllerId, params) {
        super(src, controllerId, params);
    }

    _createIframe(params) {
        let iframe = super._createIframe(params);
        iframe.setAttribute('title', '3D Secure Flow Modal');

        let styles = {
            position: "absolute",
            top: "0px",
            left: "0px",
            height: "100%",
            width: "100%",
            "z-index": "2147483647"
        };
        applyStyles(iframe, styles);

        return iframe;
    }

    appendTo(container) {
        let styles = {
            "position": "fixed",
            "z-index": "214748364",
            "top": "0px",
            "bottom": "0px",
            "right": "0px",
            "left": "0px",
            "background": "rgba(0, 0, 0, 0.5) none repeat scroll 0% 0%",
            "transition": "background 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s",
            "will-change": "background",
            "inset": "0px"
        };

        this.overlay = document.createElement("div");
        applyStyles(this.overlay, styles);
        container.insertBefore(this.overlay, container.firstChild);

        super.appendTo(this.overlay);
    }

    destroy() {
        super.destroy();

        let overlayParent = this.overlay.parentElement;
        overlayParent.removeChild(this.overlay);
    }

    _generateId() {
        return strings.unique(`__private${COMPANY_NAME}ThreeDSecureFrame`);
    }
}